// extracted by mini-css-extract-plugin
module.exports = {"dropdownTitle":"CheckboxFilterDropdown_dropdownTitle__jLxMJ","checkboxList":"CheckboxFilterDropdown_checkboxList__ghem7"};